module.exports = __webpack_public_path__ + "static/img/HarryGrant.42abad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HarryGrant.jpg
// module id = +ovt
// module chunks = 0